import { FilterOutlined } from '@ant-design/icons';
import {
    Button,
    Form, Input
} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';


const QuotationFormFilter = ({ children, data, ...otherProps }) => {
    const [form] = Form.useForm()

    const clearForm = () => {
        try {
            form.setFieldsValue(Object.fromEntries(
                Object.keys(form.getFieldsValue()).map(key => ([key, null]))
            ))
            form.submit()
        }
        catch (e) {
            console.log(e);
        }
    }

    return (
        <Form initialValues={data} form={form} layout='vertical' {...otherProps}>
            <Form.Item name="expected_delivery_date" label="Expected Delivery Date">
                <Input type="text" />
            </Form.Item>
            <Form.Item name="item_name" label="Item Name">
                <Input type="text" />
            </Form.Item>
            {/* <Form.Item name="createdAt" label="Status" >
                <DateRangePicker
                    ranges={{
                        Today: [dayjs(), dayjs()],
                        'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
                    }}
                    allowEmpty={[true, true]}
                />
            </Form.Item> */}
            {children}
            <Form.Item label=" ">
                <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>Search</Button>
                <Button onClick={clearForm} icon={<FilterOutlined />}>Reset</Button>
            </Form.Item>
        </Form>
    )
}

QuotationFormFilter.propTypes = {
    children: PropTypes.node,
    data: PropTypes.object,
}

export default QuotationFormFilter
